import { render, staticRenderFns } from "./inbu-top-banner.vue?vue&type=template&id=53d37845&"
import script from "./inbu-top-banner.vue?vue&type=script&lang=js&"
export * from "./inbu-top-banner.vue?vue&type=script&lang=js&"
import style0 from "./inbu-top-banner.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports